<template>
    <div>   
        <h2 class="primary darken-2 white--text font-weight-bold subheading pt-1 text-xs-center">Requested Withdrawal History</h2>
        <v-divider></v-divider>
        <div class="" style="max-height: 400px; overflow: auto"> 
            <v-card color="white" style="" v-for="item in requestedWithdrawals"
                :key="item.id"
            >
                <v-card-text class="px-3 py-2 " style="font-size: 12px; cursor: pointer">
                    <h2 class="teal--text" >
                        Status: 
                        <span v-if="!item.confirmed && !item.cancelled" class="blue--text">Pending <div @click="deleteWithdrawal"
                            style="position: absolute; top: 5px; right: 5px; background-color: red; color: white; border-radius: 50%; width: 24px; height: 24px; text-align: center; line-height: 24px; cursor: pointer;">
                        ×
                        </div></span>
                        <span v-else-if="item.confirmed" class="success--text">Validated</span>
                        <span v-else class="red--text">Cancelled</span>
                    </h2>
                    <!-- Modified line: Added fee information -->
                    <span><b>Request:</b> {{item.amount}} FCFA (Fixed fee: 200 FCFA) : On {{item.get_date_str}}</span>
                    <v-spacer></v-spacer>
                    <div >
                        <span v-if="item.transaction_operator == 'Topup Withdrawal'"><b>Operator:</b> Via Topup spot withdawal of Hard cash </span>
                        <span v-else><b>Operator:</b> Via {{item.transaction_operator}} into {{item.phone}} </span>
                    </div>
                </v-card-text>
            <v-divider></v-divider>
            </v-card>
            
        </div>
    </div>
</template>
<<<<<<< HEAD

=======
>>>>>>> 49458788231973cf0d721734f7a8bb0c20fbfb92
<script>
    import axios from 'axios'

    export default {
        data() {
            return {
                requestedWithdrawals: [],
            }
        },

        methods:{
            getUserRequestedWithdrawal(){
                axios
                    .get('/api/v1/savings/marketer_history/')
                    .then(response => {
                        this.requestedWithdrawals = response.data  // get the data and fill into campaigns
                        console.log(this.requestedWithdrawals)
                    })
                    .catch(error => {
                        console.log(error.response)
                        if (error.response){
                            this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
                            this.$store.commit('setSnackBarColor', "red darken-4")
                            this.$store.commit('activateSnackBar', true)
                        }else{
                            this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
                            this.$store.commit('setSnackBarColor', "red darken-4")
                            this.$store.commit('activateSnackBar', true)
                        }
                    })
            },
            async deleteWithdrawal() {
            try {
                const response = await axios.post('/api/v1/savings/delete_withdrawal/');
                this.$store.commit("setSnackBarMessage", response.data.success);
                this.$store.commit("setSnackBarColor", "teal darken-4");
                this.$store.commit("activateSnackBar", true);

                this.getUserRequestedWithdrawal();

                setTimeout(() => {
                    this.$router.push('/dashboard/affiliateMarketing/Withdrawal');
                    this.$store.commit('setSnackBarTimeOut', 4000);
                }, 4000);
            } catch (error) {
                if (error.response) {
                    this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText);
                } else {
                    this.$store.commit('setSnackBarMessage', "An error occurred, please check your internet connection and try again later.");
                }
                this.$store.commit('setSnackBarColor', "red darken-4");
                this.$store.commit('activateSnackBar', true);
            }
        },
        },
        
        mounted(){
            // executes these after the page has been mounted
            this.getUserRequestedWithdrawal();
            document.title = "PettyCash | Withdrawal History"
            this.$store.commit('setCloseURL', "/dashboard/affiliateMarketing/Withdrawal")
        },
    }
</script>
